import { motion } from "framer-motion";
import { FiUser, FiSettings } from "react-icons/fi";

const IconoUsuarioPlano = ({ scale = 1, animated = true }) => {
    // Ajuste de escala responsiva
    const size = 64 * scale;

    return (
        <div className="relative flex items-center justify-center p-2" style={{ width: size, height: size }}>

            {/* 1. Fondo Geométrico (Hexágono de Ingeniería) */}
            <svg
                viewBox="0 0 100 100"
                className="absolute inset-0 w-full h-full fill-[#F8F9FA] stroke-[#1C1C1C]/10"
                strokeWidth="1"
            >
                <polygon points="50,1 95,25 95,75 50,99 5,75 5,25" />
            </svg>

            {/* 2. Círculo de Resplandor Naranja */}
            {animated && (
                <motion.div
                    className="absolute inset-0 bg-[#F26B1D]/10 rounded-full blur-xl"
                    animate={{ scale: [1, 1.2, 1], opacity: [0.3, 0.6, 0.3] }}
                    transition={{ repeat: Infinity, duration: 3, ease: "easeInOut" }}
                />
            )}

            {/* 3. Contenedor del Icono con Sombra */}
            <motion.div
                className="relative z-10 w-full h-full bg-white/80 backdrop-blur-lg rounded-full flex items-center justify-center shadow-lg shadow-[#1C1C1C]/5 border border-white"
                whileHover={animated ? { scale: 1.05 } : {}}
            >
                {/* 4. El Icono de Usuario Minimalista */}
                <FiUser className="text-[#F26B1D]" style={{ fontSize: `${size * 0.4}px` }} />

                {/* 5. El Pequeño Engranaje (Settings) - Indica que está en configuración */}
                {animated && (
                    <motion.div
                        className="absolute -bottom-1 -right-1 bg-[#1C1C1C] text-white p-1 rounded-full shadow-md"
                        animate={{ rotate: 360 }}
                        transition={{ repeat: Infinity, duration: 6, ease: "linear" }}
                    >
                        <FiSettings size={size * 0.2} />
                    </motion.div>
                )}
            </motion.div>
        </div>
    );
};

export default IconoUsuarioPlano;